import {
  MyUser
} from '../index';

declare var Object: any;
export interface VehicleServiceInterface {
  "dateTimeIn"?: Date;
  "dateTimeOut"?: Date;
  "fleetManagerComments"?: any;
  "miles"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  "updatedById"?: number;
  "vehicle"?: any;
  "mechanicsShop"?: any;
  "fleetManagerAssigned"?: any;
  "mechanicAssigned"?: any;
  "invoices"?: any;
  "requests"?: any;
  "serviceStates"?: any;
  "schedules"?: any;
  "id"?: any;
  updatedBy?: MyUser;
}

export class VehicleService implements VehicleServiceInterface {
  "dateTimeIn": Date;
  "dateTimeOut": Date;
  "fleetManagerComments": any;
  "miles": number;
  "createdAt": Date;
  "updatedAt": Date;
  "updatedById": number;
  "vehicle": any;
  "mechanicsShop": any;
  "fleetManagerAssigned": any;
  "mechanicAssigned": any;
  "invoices": any;
  "requests": any;
  "serviceStates": any;
  "schedules": any;
  "id": any;
  updatedBy: MyUser;
  constructor(data?: VehicleServiceInterface) {
    Object.assign(this, data);
  }

  /**
   * The name of the model represented by this $resource,
   * i.e. `VehicleService`.
   */
  public static getModelName() {
    return "VehicleService";
  }

  /**
  * This method creates an instance of VehicleService for dynamic purposes.
  **/
  public static factory(data: VehicleServiceInterface): VehicleService{
    return new VehicleService(data);
  }

  /**
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VehicleService',
      plural: 'VehicleServices',
      path: 'VehicleServices',
      idName: 'id',
      properties: {
        "dateTimeIn": {
          name: 'dateTimeIn',
          type: 'Date'
        },
        "dateTimeOut": {
          name: 'dateTimeOut',
          type: 'Date'
        },
        "fleetManagerComments": {
          name: 'fleetManagerComments',
          type: 'any',
          default: <any>null
        },
        "miles": {
          name: 'miles',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "updatedById": {
          name: 'updatedById',
          type: 'number'
        },
        "vehicle": {
          name: 'vehicle',
          type: 'any',
          default: <any>null
        },
        "mechanicsShop": {
          name: 'mechanicsShop',
          type: 'any',
          default: <any>null
        },
        "fleetManagerAssigned": {
          name: 'fleetManagerAssigned',
          type: 'any',
          default: <any>null
        },
        "mechanicAssigned": {
          name: 'mechanicAssigned',
          type: 'any',
          default: <any>null
        },
        "invoices": {
          name: 'invoices',
          type: 'any',
          default: <any>null
        },
        "requests": {
          name: 'requests',
          type: 'any',
          default: <any>null
        },
        "serviceStates": {
          name: 'serviceStates',
          type: 'any',
          default: <any>null
        },
        "schedules": {
          name: 'schedules',
          type: 'any',
          default: <any>null
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
        updatedBy: {
          name: 'updatedBy',
          type: 'MyUser',
          model: 'MyUser',
          relationType: 'belongsTo',
                  keyFrom: 'updatedById',
          keyTo: 'id'
        },
      }
    }
  }
}
